import { useTranslation } from "react-i18next";
import MScreen from "../../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import { BUILD_DATE, BUILD_NUMBER } from "../../../build";

import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Store } from "../../../utils/Store";
import axios from "axios";
import { PrintUtils } from "../../../utils/PrintUtils";
import PRSelect from "../../../components/pos/PRSelect";
import API from "../../../utils/API";
import { SaleUtils } from "../../../utils/SaleUtils";
export default function MSetting(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [version, setVersion] = useState("0");
  const [buildDate, setBuildDate] = useState("");
  const [shopCode, setShopCode] = useState("");
  const [user, setUser] = useState("");

  const [printerOptions, setPrinterOptions] = useState([]);
  const [receiptPrinterPageSizeOptions, setReceiptPrinterPageSizeOptions] =
    useState([]);
  const [comPortOptions, setComPortOptions] = useState([]);

  const [receiptPrinter, setReceiptPrinter] = useState(null);

  const [receiptPrinterTwo, setReceiptPrinterTwo] = useState(null);
  const [receiptPrinterPageSize, setReceiptPrinterPageSize] = useState(null);

  const [
    receiptPrinterPageSizeForPrinterTwo,
    setReceiptPrinterPageSizeForPrinterTwo,
  ] = useState(null);

  const [imagePrinter, setImagePrinter] = useState(null);
  const [poleDisplayPort, setPoleDisplay] = useState(null);

  const [printingModeOptions, setPrintingModeOptions] = useState([
    { value: "LOCAL", label: "Local" },
    { value: "CLOUD_PRINT", label: "Cloud Print Service" },
    { value: "BLUETOOTH", label: "Bluetooth" },
  ]);

  const [printingMode, setPrintingMode] = useState({
    value: null,
    label: null,
  });

  useEffect(() => {
    if (printingMode && printingMode.value === "CLOUD_PRINT") {
      refreshCloudPrinters();
    }
    if (printingMode && printingMode.value === "LOCAL") {
      refreshLocalPrinters();
    }
  }, [printingMode]);

  useEffect(() => {
    if (props.terminalBean.printingMode) {
      setPrintingMode(
        SaleUtils.getOption2(
          printingModeOptions,
          props.terminalBean.printingMode
        )
      );
    } else {
      setPrintingMode({ value: null, label: null });
    }
  }, [props.terminalBean]);

  useEffect(() => {
    setVersion(BUILD_NUMBER);
    setBuildDate(BUILD_DATE);
    setShopCode(localStorage.getItem("w_shopCode"));
    let token = localStorage.getItem("w_accessToken");
    let jwt = Store.parseJwt(token);

    setUser(jwt.sub);
  }, []);

  useEffect(() => {
    if (props.terminalBean.printingMode == "CLOUDPRINT") {
      refreshCloudPrinters();
    } else if (props.terminalBean.printingMode == "LOCAL") {
      refreshLocalPrinters();
    }
  }, [props.terminalBean]);

  async function refreshCloudPrinters() {
    try {
      setImagePrinter(null);
      setReceiptPrinter(null);
      setReceiptPrinterTwo(null);
      setPoleDisplay(null);

      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Cloud Printers..."));
      let otherPrinters = [];

      let comports = [];

      let [url, token] = await PrintUtils.getCloudPrintToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      let devices = await axios.get(
        "/cloudprintbackend/api/v1/core/devices",
        config
      );

      console.log(devices);
      for (let device of devices.data) {
        console.log(device);
        if (device.deviceFamily === "PRINTER") {
          otherPrinters.push({
            value: device.id,
            label: device.name,
            supportedMediaSize: device.supportedMediaSize,
          });
          if (props.terminalBean.printingMode == "CLOUD_PRINT") {
            if (props.terminalBean.receiptPrinterTwo === device.id) {
              setReceiptPrinterTwo({
                value: device.id,
                label: device.name,
                supportedMediaSize: device.supportedMediaSize,
              });
              setReceiptPrinterPageSizeOptions(
                getPageSizeOptions(device.supportedMediaSize)
              );
              for (let page of device.supportedMediaSize) {
                if (
                  props.terminalBean.receiptPrinterPageSizeForPrinterTwo ===
                  page.name
                ) {
                  setReceiptPrinterPageSizeForPrinterTwo({
                    value: page.name,
                    label: page.name,
                  });
                }
              }
            }
            if (props.terminalBean.receiptPrinter === device.id) {
              setReceiptPrinter({
                value: device.id,
                label: device.name,
                supportedMediaSize: device.supportedMediaSize,
              });
              setReceiptPrinterPageSizeOptions(
                getPageSizeOptions(device.supportedMediaSize)
              );
              for (let page of device.supportedMediaSize) {
                if (props.terminalBean.receiptPrinterPageSize === page.name) {
                  setReceiptPrinterPageSize({
                    value: page.name,
                    label: page.name,
                  });
                }
              }
            }
            if (props.terminalBean.imagePrinter === device.id) {
              setImagePrinter({
                value: device.id,
                label: device.name,
                supportedMediaSize: device.supportedMediaSize,
              });
            }
          }
        }
        if (device.deviceFamily === "COM") {
          comports.push({
            value: device.id,
            label: device.name,
          });
          if (props.terminalBean.printingMode == "CLOUD_PRINT") {
            if (props.terminalBean.poleDisplayPort === device.id) {
              setPoleDisplay({
                value: device.id,
                label: device.name,
              });
            }
          }
        }
      }
      setPrinterOptions(otherPrinters);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }

  function getPageSizeOptions(options) {
    let arr = [];
    for (let o of options) {
      arr.push({
        value: o.name,
        label: o.name,
      });
    }
    console.log(arr);
    return arr;
  }

  async function refreshLocalPrinters() {
    setImagePrinter(null);
    setReceiptPrinter(null);
    setReceiptPrinterTwo(null);
    setPoleDisplay(null);
    try {
      console.log("#### refreshCloudPrinters");
      props.showProgress(translate("Checking Local Printers..."));
      let otherPrinters = [];

      let devices = await axios.get(
        "http://localhost:3337/agent/device/printers"
      );

      let comPorts = await axios.get(
        "http://localhost:3337/agent/device/comports"
      );

      for (let device of devices.data) {
        otherPrinters.push({
          value: device.id,
          label: device.name,
          supportedMediaSize: device.supportedMediaSize,
        });
        if (props.terminalBean.printingMode == "LOCAL") {
          if (props.terminalBean.receiptPrinterTwo === device.id) {
            setReceiptPrinterTwo({
              value: device.id,
              label: device.name,
              supportedMediaSize: device.supportedMediaSize,
            });
            setReceiptPrinterPageSizeOptions(
              getPageSizeOptions(device.supportedMediaSize)
            );
            for (let page of device.supportedMediaSize) {
              if (
                props.terminalBean.receiptPrinterPageSizeForPrinterTwo ===
                page.name
              ) {
                setReceiptPrinterPageSizeForPrinterTwo({
                  value: page.name,
                  label: page.name,
                });
              }
            }
          }

          if (props.terminalBean.receiptPrinter === device.id) {
            setReceiptPrinter({
              value: device.id,
              label: device.name,
              supportedMediaSize: device.supportedMediaSize,
            });
            setReceiptPrinterPageSizeOptions(
              getPageSizeOptions(device.supportedMediaSize)
            );
            for (let page of device.supportedMediaSize) {
              if (props.terminalBean.receiptPrinterPageSize === page.name) {
                setReceiptPrinterPageSize({
                  value: page.name,
                  label: page.name,
                });
              }
            }
          }
          if (props.terminalBean.imagePrinter === device.id) {
            setImagePrinter({
              value: device.id,
              label: device.name,
              supportedMediaSize: device.supportedMediaSize,
            });
          }
        }
      }
      setPrinterOptions(otherPrinters);
      let comports = [];

      for (let com of comPorts.data) {
        comports.push({
          value: com,
          label: com,
        });
        if (props.terminalBean.printingMode == "LOCAL") {
          if (props.terminalBean.poleDisplayPort === com) {
            setPoleDisplay({
              value: com,
              label: com,
            });
          }
        }
      }

      setComPortOptions(comports);

      props.hideProgress();
    } catch (err) {
      console.log(err);
      props.hideProgress();
    }
  }
  async function saveTerminalSetting() {
    try {
      let { data } = await API.get("/api/v1/terminal/" + props.terminalBean.id);
      let termBean = data;
      if (printingMode.value === "BLUETOOTH") {
        termBean.printingMode = "BLUETOOTH";
      }
      if (printingMode.value === "CLOUD_PRINT") {
        termBean.printingMode = "CLOUD_PRINT";
        termBean.receiptPrinter = receiptPrinter ? receiptPrinter.value : null;
        termBean.receiptPrinterTwo = receiptPrinterTwo
          ? receiptPrinterTwo.value
          : null;
        termBean.receiptPrinterPageSize = receiptPrinterPageSize
          ? receiptPrinterPageSize.value
          : null;
        termBean.receiptPrinterPageSizeForPrinterTwo =
          receiptPrinterPageSizeForPrinterTwo
            ? receiptPrinterPageSizeForPrinterTwo.value
            : null;
        termBean.imagePrinter = imagePrinter ? imagePrinter.value : null;
        termBean.poleDisplayPort = poleDisplayPort
          ? poleDisplayPort.value
          : null;
      }
      if (printingMode.value === "LOCAL") {
        termBean.printingMode = "LOCAL";
        termBean.receiptPrinter = receiptPrinter ? receiptPrinter.value : null;
        termBean.receiptPrinterTwo = receiptPrinterTwo
          ? receiptPrinterTwo.value
          : null;
        termBean.receiptPrinterPageSize = receiptPrinterPageSize
          ? receiptPrinterPageSize.value
          : null;
        termBean.receiptPrinterPageSizeForPrinterTwo =
          receiptPrinterPageSizeForPrinterTwo
            ? receiptPrinterPageSizeForPrinterTwo.value
            : null;
        termBean.imagePrinter = imagePrinter ? imagePrinter.value : null;
        termBean.poleDisplayPort = poleDisplayPort
          ? poleDisplayPort.value
          : null;
      }
      let result = await API.post("/api/v1/terminal", termBean);
      props.setTerminalBean(result.data);
      props.setCurrentScreen("home");
    } catch (err) {
      console.log(err);
      props.setAlert({
        show: true,
        title: "Alert!",
        message: translate("Error While Saving Terminal Settings"),
      });
    }
  }

  function onReceiptPrinterChanged(e) {
    console.log(e, printerOptions);
    setReceiptPrinter(e);
    setReceiptPrinterPageSizeOptions(getPageSizeOptions(e.supportedMediaSize));
    setReceiptPrinterPageSize(null);
  }

  function onReceiptPrinterChangedTwo(e) {
    setReceiptPrinterTwo(e);
    setReceiptPrinterPageSizeOptions(getPageSizeOptions(e.supportedMediaSize));
    setReceiptPrinterPageSizeForPrinterTwo(null);
  }
  return (
    <MScreen
      title={translate("Settings")}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("home")}
      rightAction={translate("Save")}
      onRightAction={() => {
        //props.onOkay(props.value);
        saveTerminalSetting();
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      dialogMode={true}
      position={props.context.appMode === "desktop-pos" ? "static" : "fixed"}
      content={
        <div style={{ marginTop: 10, height: "480px" }}>
          <Grid container>
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("Shop Code")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {shopCode}
            </Grid>{" "}
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("App Version")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {version}
            </Grid>{" "}
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("App Build Date")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {buildDate}
            </Grid>{" "}
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("Device Id")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {props.deviceId}
            </Grid>{" "}
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("Terminal")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {props.terminalBean.name}
            </Grid>{" "}
            <Grid item xs={12}>
              {translate("Printing Mode")}
            </Grid>
            <Grid item xs={12}>
              <PRSelect
                options={printingModeOptions}
                onChange={(e) => {
                  setPrintingMode(e);
                }}
                value={printingMode}
              ></PRSelect>
            </Grid>
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  {translate("Invoice Printer 1")}
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={printerOptions}
                    onChange={(e) => {
                      onReceiptPrinterChanged(e);
                    }}
                    value={receiptPrinter}
                  ></PRSelect>
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  {translate("Page Size for Printer 1")}
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={receiptPrinterPageSizeOptions}
                    onChange={(e) => {
                      setReceiptPrinterPageSize(e);
                    }}
                    value={receiptPrinterPageSize}
                  ></PRSelect>
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  {translate("Invoice Printer 2")}
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={printerOptions}
                    onChange={(e) => {
                      console.log("EEE", e);
                      onReceiptPrinterChangedTwo(e);
                    }}
                    value={receiptPrinterTwo}
                  ></PRSelect>
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  {translate("Page Size for Printer 2")}
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={receiptPrinterPageSizeOptions}
                    onChange={(e) => {
                      setReceiptPrinterPageSizeForPrinterTwo(e);
                    }}
                    value={receiptPrinterPageSizeForPrinterTwo}
                  ></PRSelect>
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={6}>
                  {translate("Image Printer")}
                </Grid>
              )}
            {printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={printerOptions}
                    onChange={(e) => {
                      console.log(e);
                      setImagePrinter(e);
                    }}
                    value={imagePrinter}
                  ></PRSelect>
                </Grid>
              )}
            {props.context.appMode === "desktop-pos" &&
              printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={6}>
                  {translate("Pole Display")}
                </Grid>
              )}
            {props.context.appMode === "desktop-pos" &&
              printingMode &&
              (printingMode.value === "CLOUD_PRINT" ||
                printingMode.value === "LOCAL") && (
                <Grid item xs={12}>
                  <PRSelect
                    options={comPortOptions}
                    onChange={(e) => {
                      setPoleDisplay(e);
                    }}
                    value={poleDisplayPort}
                  ></PRSelect>
                </Grid>
              )}
          </Grid>
        </div>
      }
    ></MScreen>
  );
}
